export class TransferOwnershipReqRes {
  public fromId: number;
  public toId: number;
  public investmentAmount: number;
  public commitmentAmount: number;
  public closingDate: Date;
}
